import { IFlagVariantConfig } from "libs/hooks/src";

// A/B flag for the v6 pricing page.
export const SUF_V6_LAUNCH: IFlagVariantConfig = {
  id: "suf-v6-launch",
  variant: "test",
};
